module.exports = __webpack_public_path__ + "static/img/image-benefit.0249d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/image-benefit/image-benefit.png
// module id = RHii
// module chunks = 35